import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faSearch,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/Driver.css";
import { Rating } from "react-simple-star-rating";
import axios from "axios";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation } from "react-router-dom";
import StarRating from "./Components/StarRating";
import StatusTypeModel from "./Components/StatusSubModal";

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};

export default function Driver() {
  const location = useLocation();
  // const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewUrlUpdate, setPreviewUrlUpdate] = useState("");
  const [previewUrlLicense, setPreviewUrlLicense] = useState("");
  const [previewUrlUpdateLicense, setPreviewUrlUpdateLicense] = useState("");

  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => setModalIsOpen(false);
  const [rating, setRating] = useState(0);
  const [DriverList, SetDriverList] = useState([]);
  const [DriverStatus, SetDriverStatus] = useState([]);
  const [DriverDrinkingHabit, SetDriverDrinkingHabit] = useState([]);
  const [DriverRating, SetDriverRating] = useState(0);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [isDateInput, setIsDateInput] = useState(false);
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");

  const [subModalIsOpen, setSubModalIsOpen] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [statusTypeSub, setStatusTypeSub] = useState({
    Status: null,
    Status_Ref: null,
  });

  const handleSubModalOpen = () => setSubModalIsOpen(true);
  const handleSubModalClose = () => setSubModalIsOpen(false);

  const handleStatusOnChange = async (e) => {
    let { name, value } = e.target;
    setStatusTypeSub({ ...statusTypeSub, [name]: value.toUpperCase() });
  };

  function selectStatusType(statusType) {
    switch (statusType) {
      case "Driver Status":
        return "Driver_Status";
        break;
      case "Drinking Habit":
        return "Driver_Drinking_Habit";
        break;

      default:
        break;
    }
  }

  const handleStatusTypeSubjectSubmit = async (event) => {
    event.preventDefault();
    const status = statusType ? selectStatusType(statusType) : "";
    console.log(status, statusType);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/${status}`,
          statusTypeSub,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            setStatusTypeSub({ Status: null, Status_Ref: null });
            if (statusType === "Driver Status") fetchDriverStatus();
            if (statusType === "Drinking Habit") fetchDriverDrinkingHabit();
            setStatusType(null);
            handleSubModalClose();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const filteredDriver = searchQuery
    ? DriverList.filter((item) =>
        item.Driver_Name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : DriverList;

  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
  const maxSize = 2 * 1024 * 1024;

  const InitState = {
    driverName: null,
    driverGender: "Male",
    driverStatus: "Permenent",
    contactNumber1: null,
    contactNumber2: null,
    whatsappNumber: null,
    emergencyContact: null,
    driverPhoto: "",
    relationName: null,
    driverRelation: "Father",
    address1: null,
    address2: null,
    bloodGroup: "A+",
    driverHabit: "No",
    licenseNumber: null,
    licenseValidUpto: null,
    licensePhoto: "",
    user: username,
    driverRating: 0,
    lastThreeTripRating: 0,
  };

  const [formData, setFormData] = useState(InitState);

  /*
const FetchRating = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/FetchDriverRating",selectedDriver.Driver_Name);
    //console.log("Fetched data:", response.data);// Log the fetched data
    SetDriverRating(response.data);
    setModalIsOpen(true)
  } catch (error) {
    console.error("Error fetching form data:", error);
  }
};
*/

  const fetchDriverStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Driver_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data

      SetDriverStatus(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const fetchDriverDrinkingHabit = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Driver_Drinking_Habit`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetDriverDrinkingHabit(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const fetchDriverList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/driver/FetchDriverList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );

      //console.log("Fetched data:", response.data);// Log the fetched data
      SetDriverList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchDriverList();
    fetchDriverStatus();
    fetchDriverDrinkingHabit();
    setUsername(sessionStorage.getItem("username"));
    setRights(sessionStorage.getItem("rights"));
  }, []);

  const handleDriverPhotoUpdate = (e) => {
    let value = e.target.files[0];
    if (!allowedTypes.includes(value.type)) {
      WarningMSG("Only .jpg, .jpeg, .png formats are allowed");
      value = e.target.files[0];
    } else if (value.size > maxSize) {
      WarningMSG("File size should not exceed 2MB");
      value = e.target.files[0];
    } else {
      setSelectedDriver({
        ...selectedDriver,
        driverPhoto: value,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrlUpdate(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleDriverPhoto = (e) => {
    let value = e.target.files[0];
    if (!allowedTypes.includes(value.type)) {
      WarningMSG("Only .jpg, .jpeg, .png formats are allowed");
      value = e.target.files[0];
    } else if (value.size > maxSize) {
      WarningMSG("File size should not exceed 2MB");
      value = e.target.files[0];
    } else {
      setFormData({
        ...formData,
        driverPhoto: value,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
    //console.log("photo",e.target.files[0]);
  };

  const handleDriverLicenseUpdate = (e) => {
    let value = e.target.files[0];
    if (!allowedTypes.includes(value.type)) {
      WarningMSG("Only .jpg, .jpeg, .png formats are allowed");
      value = e.target.files[0];
    } else if (value.size > maxSize) {
      WarningMSG("File size should not exceed 2MB");
      value = e.target.files[0];
    } else {
      setSelectedDriver({
        ...selectedDriver,
        licensePhoto: value,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrlUpdateLicense(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleDriverLicense = (e) => {
    let value = e.target.files[0];
    if (!allowedTypes.includes(value.type)) {
      WarningMSG("Only .jpg, .jpeg, .png formats are allowed");
      value = e.target.files[0];
    } else if (value.size > maxSize) {
      WarningMSG("File size should not exceed 2MB");
      value = e.target.files[0];
    } else {
      setFormData({
        ...formData,
        licensePhoto: value,
      });
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewUrlLicense(reader.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    //console.log(name,value);
    const pattern = /[^a-zA-Z ]/g;
    const pattern1 = /[^a-zA-Z0-9 ]/g;
    const pattern2 = /^[a-zA-Z0-9]*$/g;
    if (name === "driverName" || name === "relationName") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^a-zA-Z\s]/g, "").toUpperCase(),
        });
      }
    } else if (
      name === "contactNumber1" ||
      name === "contactNumber2" ||
      name === "whatsappNumber" ||
      name === "emergencyContact"
    ) {
      if (value > 9999999999) {
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 10),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else if (name === "licenseNumber") {
      let result = pattern2.test(value);
      if (!result) {
        const val = value.toUpperCase();
        setFormData({
          ...formData,
          [name]: val.replace(/[^a-zA-Z0-9]/g, ""),
        });
      } else if (name === "driverRating" || name === "lastThreeTripRating") {
        setFormData({
          ...formData,
          [name]: value,
        });
      } else {
        setFormData({
          ...formData,
          [name]: value.toUpperCase(),
        });
      }
    } else if (name === "licenseValidUpto") {
      let date = new Date(e.target.value);
      //console.log((convert(date)))
      if (!isNaN(date)) {
        setFormData({
          ...formData,
          [name]: convert(date),
        }); // Switch back to text to display the formatted date
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    const pattern1 = /[^a-zA-Z0-10 ]/g;
    const pattern2 = /^[a-zA-Z0-9]*$/g;
    if (name === "driverName" || name === "relationName") {
      let result = pattern.test(value);
      if (result) {
        setSelectedDriver({
          ...selectedDriver,
          [name]: value
            .replace(pattern, "")
            .replace(/[^a-zA-Z\s]/g, "")
            .toUpperCase(),
        });
      } else {
        setSelectedDriver({
          ...selectedDriver,
          [name]: value.replace(/[^a-zA-Z\s]/g, "").toUpperCase(),
        });
      }
    } else if (
      name === "contactNumber1" ||
      name === "contactNumber2" ||
      name === "whatsappNumber" ||
      name === "emergencyContact"
    ) {
      if (value > 9999999999) {
        setSelectedDriver({
          ...selectedDriver,
          [name]: value.replace(/[^0-9]/g, "").slice(0, 10),
        });
      } else {
        setSelectedDriver({
          ...selectedDriver,
          [name]: value.replace(/[^0-9]/g, ""),
        });
      }
    } else if (name === "licenseNumber") {
      let result = pattern2.test(value);
      if (!result) {
        const val = value.toUpperCase();
        setSelectedDriver({
          ...selectedDriver,
          [name]: val.replace(/[^a-zA-Z0-9]/g, "").slice(0, 15),
        });
      } else {
        setSelectedDriver({
          ...selectedDriver,
          [name]: value.toUpperCase(),
        });
      }
    } else if (name === "licenseValidUpto") {
      let date = new Date(e.target.value);
      //console.log((convert(date)))
      if (!isNaN(date)) {
        setSelectedDriver({
          ...selectedDriver,
          [name]: convert(date),
        });
        // Switch back to text to display the formatted date
      }
    } else {
      setSelectedDriver({
        ...selectedDriver,
        [name]: value,
      });
    }
  };
  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: false, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = async (Driver) => {
    try {
      //console.log(Driver.Driver_Name);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/driver/FetchDriverRating/${Driver.Driver_Name}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        }
      );
      //console.log("Fetched data:", Math.round(response.data[0].Rating));// Log the fetched data
      //console.log(response.data)
      response.data.length == 0
        ? SetDriverRating(0)
        : SetDriverRating(Math.round(response.data[0].Rating));

      setModalIsOpen(true);
    } catch (error) {
      console.error("Error fetching form data:", error.message);
    }
    const InitStateEdit = {
      driverId: Driver.Driver_Id,
      driverName: Driver.Driver_Name,
      driverGender: Driver.Gender,
      driverStatus: Driver.Driver_Status,
      contactNumber1: Driver.Contact_Number1,
      contactNumber2: Driver.Contact_Number2,
      whatsappNumber: Driver.WhatsApp_Number,
      emergencyContact: Driver.Emg_Number,
      driverPhoto: "",
      DriverPhoto: Driver.Driver_Photo,
      relationName: Driver.Relation_Name,
      driverRelation: Driver.Driver_Relation,
      address1: Driver.Address1,
      address2: Driver.Address2,
      bloodGroup: Driver.Blood_Group,
      driverHabit: Driver.Drinking_Habit,
      licenseNumber: Driver.License_Number,
      licenseValidUpto:
        Driver.License_Valid_Upto == null
          ? null
          : convert(Driver.License_Valid_Upto.toString()),
      licensePhoto: "",
      LicensePhoto: Driver.License_Photo,
      user: username,
    };
    setSelectedDriver(InitStateEdit);

    //console.log(InitStateEdit)
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if (confirmClose) {
      setModalIsOpen(false);
      setFormData(InitState);
      SetDriverRating(0);
      setSelectedDriver(null);
    }
  };
  const handleFocus = () => {
    setIsDateInput(true);
  };
  const handleFocus1 = () => {
    setIsDateInput(false);
  };

  const UpdateForm = async (e) => {
    e.preventDefault();
    console.log(selectedDriver);
    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/driver/UpdateDriver/${selectedDriver.driverId}`,
          selectedDriver,
          {
            headers: {
              "content-type": "multipart/form-data",
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedDriver([]);
          setPreviewUrlLicense("");
          setPreviewUrlUpdateLicense("");
          setPreviewUrl("");
          setPreviewUrlUpdate("");
          fetchDriverList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
    //console.log(formData);
    closeModal();
  };
  const handleDelete = async (Driver) => {
    try {
      const confirm = window.confirm("Are you sure you want to delete this?");
      if (!confirm) return;
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/driver/DeleteDriver/${Driver.Driver_Id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchDriverList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (formData.licenseValidUpto === null) {
      WarningMSG("Fill Mandatory Fields");
    } else {
      //console.log(formData)
      try {
        await axios
          .post(
            `${process.env.REACT_APP_API_BASE_URL}/driver/AddDriver`,
            formData,
            {
              headers: {
                "content-type": "multipart/form-data",
                Authorization: `Bearer ${sessionStorage.getItem(
                  "access_token"
                )}`,
              },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              fetchDriverList();
              SuccessMSG(res.data.message);
              setPreviewUrlLicense("");
              setPreviewUrlUpdateLicense("");
              setPreviewUrl("");
              setPreviewUrlUpdate("");
              fetchDriverList();
            } else if (res.status === 201) FailedMSG(res.data);
          })
          .catch((error) => {
            if (error.response && error.response.status !== 200)
              FailedMSG("Something went Wrong");
          });
        fetchDriverList();
      } catch (error) {
        if (error.response && error.response.status !== 200)
          FailedMSG("Something went Wrong");
      }
      //console.log(formData);
      setFormData(InitState);
      closeModal();
    }
  };

  const today = new Date().toISOString().split("T")[0];
  return (
    <>
      <ToastContainer />
      <Appbar username={username} rights={rights}></Appbar>
      <div className="Driver">
        <Menu username={username} rights={rights} i={"MasterSetup"}></Menu>
        <div className="DriverPage">
          <p className="DriverHeadLabel">Drivers</p>
          <div className="DriverHeaders">
            <div className="DriverRegSearch">
              <input
                className="DriverRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Driver Name"
              ></input>
              <button className="DriverSearchBtn">
                <FontAwesomeIcon
                  className="DriverRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button
              className="NewDriverBtn"
              title="Add Driver"
              onClick={openModal}
            >
              Add Driver
              <FontAwesomeIcon
                className="DriverAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleModalClose}
            contentLabel="Driver Form"
            shouldCloseOnOverlayClick={false}
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "25%",
                right: "25%",
                bottom: "40px",
                height: "auto",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="DriverPageFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="DriverPageFormHeadLabel">
              {selectedDriver?.driverId ? "Edit Driver" : "Add Driver"}
            </p>
            <form
              className="DriverPageForm"
              onSubmit={selectedDriver?.driverId ? UpdateForm : handleSubmit}
            >
              <div className="DriverPageFormFlex">
                <div className="DriverPageformHeader">
                  <div className="DriverPageFormHeader0">
                    <div className="DriverPageformHeadFeilds">
                      <label className="DriverPageFormLabels">
                        Driver Name <span>*</span>{" "}
                      </label>
                      <input
                        placeholder="Driver Name"
                        value={
                          selectedDriver?.driverName || formData.driverName
                        }
                        onChange={selectedDriver ? handleUpdate : handleChange}
                        required
                        className="DriverPageFormInputs"
                        type="text"
                        name="driverName"
                      ></input>
                    </div>
                    <div className="DriverPageformHeadFeilds">
                      <label className="DriverPageFormLabels">
                        Gender <span>*</span>
                      </label>
                      <select
                        className="DriverPageFormSelects"
                        value={
                          selectedDriver?.driverGender || formData.driverGender
                        }
                        onChange={selectedDriver ? handleUpdate : handleChange}
                        required
                        name="driverGender"
                      >
                        <option>Male</option>
                        <option>Female</option>
                        <option>Transgender</option>
                      </select>
                    </div>
                    <div className="DriverPageformHeadFeilds">
                      <label className="DriverPageFormLabels">
                        Driver Status <span>*</span>{" "}
                        <Link
                          style={{ fontSize: "12px" }}
                          state={{ username: username, rights: rights }}
                          to={""}
                          onClick={() => {
                            setStatusType("Driver Status");
                            handleSubModalOpen();
                          }}
                        >
                          {" "}
                          (Add Status)
                        </Link>
                      </label>
                      <select
                        className="DriverPageFormSelects"
                        value={
                          selectedDriver?.driverStatus || formData.driverStatus
                        }
                        onChange={selectedDriver ? handleUpdate : handleChange}
                        required
                        name="driverStatus"
                      >
                        <option value={""}>Select</option>
                        {DriverStatus.map((item, index) => (
                          <option key={index} value={item.Status_Ref}>
                            {item.Status_Ref}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="DriverPageFormHeader1">
                    <div className="DriverPageFormHeaderPhoto">
                      <div className="DriverPageFormPhoto">
                        {selectedDriver ? (
                          previewUrlUpdate === "" ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}${
                                selectedDriver.DriverPhoto
                                  ? selectedDriver.DriverPhoto.replace(
                                      /public\\/g,
                                      "/"
                                    )
                                  : ""
                              }`}
                              alt="Driver"
                            ></img>
                          ) : (
                            <img src={previewUrlUpdate} alt="Driver"></img>
                          )
                        ) : previewUrl === "" ? (
                          <img src={""} alt="Driver"></img>
                        ) : (
                          <img src={previewUrl} alt="Driver"></img>
                        )}
                      </div>
                      <div className="DriverPageformHeadFeildsDR">
                        <label
                          htmlFor="photo"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "30px",
                          }}
                          className="DriverPageFormPhotoInputs"
                        >
                          <FontAwesomeIcon icon={faCamera}></FontAwesomeIcon>
                        </label>
                        <label className="DriverPageFormLabels">
                          Driver Photo{" "}
                        </label>
                        <input
                          id="photo"
                          style={{ display: "none" }}
                          type="file"
                          accept="image/*"
                          onChange={
                            selectedDriver
                              ? handleDriverPhotoUpdate
                              : handleDriverPhoto
                          }
                          name="driverPhoto"
                        ></input>
                      </div>
                    </div>
                    <div className="DriverPageFormHeaderDriverRatings">
                      <div className="DriverPageFormPhoto1">
                        {selectedDriver ? (
                          previewUrlUpdateLicense === "" ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}${
                                selectedDriver.LicensePhoto
                                  ? selectedDriver.LicensePhoto.replace(
                                      /public\\/g,
                                      "/"
                                    )
                                  : ""
                              }`}
                              alt="License"
                            ></img>
                          ) : (
                            <img
                              src={previewUrlUpdateLicense}
                              alt="License"
                            ></img>
                          )
                        ) : previewUrlLicense === "" ? (
                          <img src={InitState.licensePhoto} alt="License"></img>
                        ) : (
                          <img src={previewUrlLicense} alt="License"></img>
                        )}
                      </div>
                      <div className="DriverRattings col-12">
                        <div className="DriverRattingslables col-6">
                          <label className="DriverPageFormLabels">
                            Driver Rating{" "}
                          </label>
                          <Rating
                          readonly
                            size={25}
                            className="TripClosureStarRatting"
                            emptyColor="white"
                            initialValue={
                              selectedDriver?.driverRating ||
                              formData.driverRating
                            }
                            onClick={(value) => {
                              console.log("Selected Rating:", value); // Debugging
                              setSelectedDriver({
                                ...selectedDriver,
                                driverRating: value,
                              });
                            }}
                          />
                          {/* <StarRating DriverRating={DriverRating} /> */}
                        </div>
                        <div className="DriverRattingslables col-6">
                          <label className="DriverPageFormLabels">
                            Last Three Trip Rating{" "}
                          </label>
                          <Rating
                          readonly
                            size={25}
                            className="TripClosureStarRatting"
                            emptyColor="white"
                            initialValue={
                              selectedDriver?.lastThreeTripRating ||
                              formData.lastThreeTripRating
                            }
                            onClick={(value) => {
                              console.log("Selected Rating:", value); // Debugging
                              setSelectedDriver({
                                ...selectedDriver,
                                lastThreeTripRating: value,
                              });
                            }}
                          />
                          {/* <StarRating /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="DriverPageform1">
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      Contact Number 1 <span>*</span>
                    </label>
                    <input
                      required
                      placeholder="XXXXXXXXXX"
                      value={
                        selectedDriver?.contactNumber1 ||
                        formData.contactNumber1
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      pattern="^[0-9]{10,10}$"
                      title="Please give 10 digit"
                      className="DriverPageFormInputs"
                      type="text"
                      name="contactNumber1"
                    ></input>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      Contact Number 2{selectedDriver ? <span>*</span> : ""}
                    </label>
                    <input
                      placeholder="XXXXXXXXXX"
                      value={
                        selectedDriver?.contactNumber2 ||
                        formData.contactNumber2
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      pattern="^[0-9]{10,10}$"
                      title="Please give 10 digit"
                      className="DriverPageFormInputs"
                      type="text"
                      name="contactNumber2"
                    ></input>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      WhatsApp Number <span>*</span>
                    </label>
                    <input
                      required
                      placeholder="XXXXXXXXXX"
                      value={
                        selectedDriver?.whatsappNumber ||
                        formData.whatsappNumber
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      pattern="^[0-9]{10,10}$"
                      title="Please give 10 digit"
                      className="DriverPageFormInputs"
                      type="text"
                      name="whatsappNumber"
                    ></input>
                  </div>
                </div>
                <div className="DriverPageform1">
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      Emergency Contact <span>*</span>
                    </label>
                    <input
                      required
                      placeholder="XXXXXXXXXX"
                      value={
                        selectedDriver?.emergencyContact ||
                        formData.emergencyContact
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      pattern="^[0-9]{10,10}$"
                      title="Please give 10 digit"
                      className="DriverPageFormInputs"
                      type="text"
                      name="emergencyContact"
                    ></input>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      Emergency Contact Name{" "}
                    </label>
                    <input
                      placeholder="Name"
                      className="DriverPageFormInputs"
                      value={
                        selectedDriver?.relationName || formData.relationName
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      type="text"
                      name="relationName"
                    ></input>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">Relation </label>
                    <select
                      className="DriverPageFormSelects"
                      value={
                        selectedDriver?.driverRelation ||
                        formData.driverRelation
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      name="driverRelation"
                    >
                      <option value={""}>Select</option>
                      <option value={"Parent"}>Parent</option>
                      <option value={"Wife"}>Wife</option>
                      <option value={"Friend"}>Friend</option>
                      <option value={"Siblings"}>Siblings</option>
                    </select>
                  </div>
                </div>
                <div className="DriverPageform1">
                  <div className="DriverPageformFeildsAddress">
                    <label className="DriverPageFormLabels">
                      Address 1 <span>*</span>
                    </label>
                    <textarea
                      required
                      placeholder="Address"
                      value={selectedDriver?.address1 || formData.address1}
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      className="DriverPageFormInputs1"
                      type="number"
                      name="address1"
                    ></textarea>
                  </div>
                </div>
                <div className="DriverPageform1">
                  <div className="DriverPageformFeildsAddress">
                    <label className="DriverPageFormLabels">Address 2</label>
                    <textarea
                      placeholder="Address"
                      className="DriverPageFormInputs1"
                      value={selectedDriver?.address2 || formData.address2}
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      type="number"
                      name="address2"
                    ></textarea>
                  </div>
                </div>
                <div className="DriverPageform1">
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">Blood Group</label>
                    <select
                      className="DriverPageFormSelects"
                      value={selectedDriver?.bloodGroup || formData.bloodGroup}
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      name="bloodGroup"
                    >
                      <option>A+</option>
                      <option>B+</option>
                      <option>A-</option>
                      <option>B-</option>
                      <option>AB+</option>
                      <option>AB-</option>
                      <option>O+</option>
                      <option>O-</option>
                    </select>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      Drinking Habit{" "}
                      <Link
                        style={{ fontSize: "12px" }}
                        state={{ username: username, rights: rights }}
                        to={""}
                        onClick={() => {
                          setStatusType("Drinking Habit");
                          handleSubModalOpen();
                        }}
                      >
                        {" "}
                        (Add Habit)
                      </Link>{" "}
                    </label>
                    <select
                      className="DriverPageFormSelects"
                      value={
                        selectedDriver?.driverHabit || formData.driverHabit
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      name="driverHabit"
                    >
                      <option value={""}>Select</option>
                      {DriverDrinkingHabit.map((item, index) => (
                        <option key={index} value={item.Status_Ref}>
                          {item.Status_Ref}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="DriverPageform1">
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      License Number <span>*</span>
                    </label>
                    <input
                      required
                      placeholder="Licence Number"
                      value={
                        selectedDriver?.licenseNumber || formData.licenseNumber
                      }
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      minLength={10}
                      maxLength={15}
                      title="Please give 15 digit"
                      className="DriverPageFormInputs form-control px-2"
                      type="text"
                      name="licenseNumber"
                    ></input>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      License Valid Upto <span>*</span>
                    </label>
                    <input
                      required
                      type={isDateInput ? "date" : "text"}
                      onFocus={handleFocus}
                      onBlur={handleFocus1}
                      readOnly={!isDateInput}
                      value={
                        selectedDriver
                          ? selectedDriver.licenseValidUpto
                            ? FormatDate(selectedDriver.licenseValidUpto)
                            : selectedDriver.licenseValidUpto
                          : formData.licenseValidUpto
                          ? FormatDate(formData.licenseValidUpto)
                          : formData.licenseValidUpto
                      }
                      min={today}
                      placeholder="01-Jan-2025"
                      onChange={selectedDriver ? handleUpdate : handleChange}
                      className="DriverPageFormInputs"
                      name="licenseValidUpto"
                    ></input>
                  </div>
                  <div className="DriverPageformFeilds">
                    <label className="DriverPageFormLabels">
                      License Photo{" "}
                    </label>
                    <label
                      htmlFor="licensePhoto"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "30px",
                      }}
                      className="DriverPageFormInputs"
                    >
                      <FontAwesomeIcon icon={faCamera}></FontAwesomeIcon>
                    </label>
                    <input
                      placeholder="Licence"
                      id="licensePhoto"
                      style={{ display: "none" }}
                      accept="image/*"
                      onChange={
                        selectedDriver
                          ? handleDriverLicenseUpdate
                          : handleDriverLicense
                      }
                      className="DriverPageFormInputs"
                      type="file"
                      name="licensePhoto"
                    ></input>
                  </div>
                </div>
              </div>
              <div className="DriverPageFormFooter">
                <div className="DriverPageFormFooterBtns">
                  <button
                    className="DriverPageFormSubmitBtn"
                    title="Submit"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <StatusTypeModel
            isOpen={subModalIsOpen}
            onClose={handleSubModalClose}
            statusTypeSub={statusTypeSub}
            handleChange={handleStatusOnChange}
            handleSubmit={handleStatusTypeSubjectSubmit}
            statusType={statusType}
          />
          <div className="DriverLists">
            {filteredDriver.length < 1 ? (
              <p style={{ textAlign: "center", width: "100%" }}>
                There is No Driver
              </p>
            ) : (
              filteredDriver.map((items, index) => {
                return (
                  <div className="DriverIndex">
                    <div className="DriverGrp0">
                      <div className="DriverIconGrp">
                        {items.Driver_Photo ? (
                          <img
                            src={`${process.env.REACT_APP_API_BASE_URL}${
                              items.Driver_Photo
                                ? items.Driver_Photo.replace(/public\\/g, "/")
                                : ""
                            }`}
                            className="DriverImageCircle"
                            alt="Driver"
                          ></img>
                        ) : (
                          <FontAwesomeIcon
                            className="DriverUsesCircle"
                            icon={faUserCircle}
                          ></FontAwesomeIcon>
                        )}
                      </div>
                      <div className="DriverGrp" style={{ width: "80%" }}>
                        <p className="DriverGrpLables">Driver Name</p>
                        <p className="DriverGrpValues">{items.Driver_Name}</p>
                      </div>
                    </div>
                    <div className="DriverGrp">
                      <p className="DriverGrpLables">Driver Contact</p>
                      <p className="DriverGrpValues">{items.Contact_Number1}</p>
                    </div>
                    <div className="DriverGrp">
                      <p className="DriverGrpLables">Status</p>
                      <p className="DriverGrpValues">{items.Driver_Status}</p>
                    </div>
                    <div className="DriverGrp">
                      <p className="DriverGrpLables">License Validity</p>
                      <p className="DriverGrpValues">
                        {FormatDate(convert(items.License_Valid_Upto))}
                      </p>
                    </div>
                    <div className="DriverGrpBtn">
                      <FontAwesomeIcon
                        className="DriverEditIcon"
                        title="Edit"
                        onClick={() => handleEdit(items)}
                        icon={faEdit}
                      ></FontAwesomeIcon>
                      <FontAwesomeIcon
                        className="DriverDeleteIcon"
                        title="Delete"
                        onClick={() => handleDelete(items)}
                        icon={faTrash}
                      ></FontAwesomeIcon>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
